import React from 'react';

const SummaryCard = ({ label, value }) => (
    <div style={{
        backgroundColor: '#262626',
        border: '1px solid #373737',
        borderRadius: '6px',
        padding: '16px'
    }}>
        <div style={{
            fontSize: '12px',
            color: '#909090',
            textTransform: 'uppercase',
            marginBottom: '8px',
            fontWeight: '600',
            letterSpacing: '0.5px'
        }}>
            {label}
        </div>
        <div style={{
            fontSize: '18px',
            color: '#e0e0e0',
            fontWeight: '600'
        }}>
            {value}
        </div>
    </div>
);

export default SummaryCard;






